import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { ParkingService } from '../lib/parking.service'
import { GET_AUTOS } from './useAutos'

export const useDeleteAuto = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<null>,
    AxiosError<ServerValidationError>,
    string
  >({
    mutationFn: id => ParkingService.deleteAuto(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [GET_AUTOS] })
  })
}
